export const INFOSECTION = {
  home: {
    heading: 'HELLO',
    subheading:
      'We design and develop beautiful and memorablewebsites with user-centric, mobile-first design approach for great user experience and enhanced conversions, ensuring &nbsp;<strong>high performance, security and scalability.</strong>',
  },
  react: {
    heading: 'REACT',
    subheading: 'We create react apps',
  },
  wordpress: {
    heading: 'WORDPRESS',
    subheading: 'We create large scale wordpress websites',
  },
  ecommerce: {
    heading: 'ECOMMERCE',
    subheading: 'We create great Ecommerce websites',
  },
  graphics: {
    heading: 'UX/UI/LOGOS',
    subheading: 'We create UI/UX and LOGOS',
  },
  application: {
    heading: 'APPS',
    subheading: 'We create apps from IOS and Android',
  },
  seo: {
    heading: 'SEO',
    subheading: 'We help optimize your website for search engines',
  },
};